import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminAudit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit?limit=300").then(({ data }) => setItems(data)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">Segurança</div>
        <h1 className="font-heading text-5xl mt-2">Auditoria</h1>
      </div>
      <div className="card-surface overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead>
            <tr className="bg-[var(--muted)] text-left">
              <th className="px-4 py-3">Data</th>
              <th className="px-4 py-3">Ação</th>
              <th className="px-4 py-3">Utilizador</th>
              <th className="px-4 py-3">Entidade</th>
              <th className="px-4 py-3">IP</th>
              <th className="px-4 py-3">Payload</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-[var(--border)]">
                <td className="px-4 py-2 text-xs whitespace-nowrap">{new Date(a.created_at).toLocaleString("pt-PT")}</td>
                <td className="px-4 py-2"><span className="chip chip-neutral">{a.action}</span></td>
                <td className="px-4 py-2 text-xs">{a.user_email || "—"}</td>
                <td className="px-4 py-2 text-xs">{a.entity} {a.entity_id ? `· ${a.entity_id.slice(0,8)}` : ""}</td>
                <td className="px-4 py-2 text-xs">{a.ip}</td>
                <td className="px-4 py-2 text-xs max-w-xs truncate">{a.payload ? JSON.stringify(a.payload) : ""}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-[var(--ink-soft)]">Sem registos.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
